/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedClientiRouteImport } from './routes/_authenticated/clienti'
import { Route as AuthenticatedDocumenteRouteImport } from './routes/_authenticated/documente'
import { Route as AuthenticatedSetariRouteImport } from './routes/_authenticated/setari'
import { Route as AuthenticatedTehnicRouteImport } from './routes/_authenticated/tehnic'
import { Route as AuthenticatedTemplateUriRouteImport } from './routes/_authenticated/template-uri'
import { Route as SemnareTokenRouteImport } from './routes/semnare.$token'
import { Route as AuthenticatedClientiIndexRouteImport } from './routes/_authenticated/clienti/index'
import { Route as AuthenticatedClientiCustomerIdRouteImport } from './routes/_authenticated/clienti/$customerId'
import { Route as AuthenticatedClientiNouRouteImport } from './routes/_authenticated/clienti/nou'
import { Route as AuthenticatedContaEfacturaRouteImport } from './routes/_authenticated/conta/efactura'
import { Route as AuthenticatedContaFacturareRouteImport } from './routes/_authenticated/conta/facturare'
import { Route as AuthenticatedContaParteneriRouteImport } from './routes/_authenticated/conta/parteneri'
import { Route as AuthenticatedDocumenteIndexRouteImport } from './routes/_authenticated/documente/index'
import { Route as AuthenticatedDocumenteDocumentIdRouteImport } from './routes/_authenticated/documente/$documentId'
import { Route as AuthenticatedDocumenteInAsteptareRouteImport } from './routes/_authenticated/documente/in-asteptare'
import { Route as AuthenticatedDocumenteIncarcaRouteImport } from './routes/_authenticated/documente/incarca'
import { Route as AuthenticatedSetariIndexRouteImport } from './routes/_authenticated/setari/index'
import { Route as AuthenticatedSetariEmailRouteImport } from './routes/_authenticated/setari/email'
import { Route as AuthenticatedSetariJurnalRouteImport } from './routes/_authenticated/setari/jurnal'
import { Route as AuthenticatedSetariPacheteRouteImport } from './routes/_authenticated/setari/pachete'
import { Route as AuthenticatedSetariProfileClientRouteImport } from './routes/_authenticated/setari/profile-client'
import { Route as AuthenticatedSetariSpvRouteImport } from './routes/_authenticated/setari/spv'
import { Route as AuthenticatedSetariSurseDeDateRouteImport } from './routes/_authenticated/setari/surse-de-date'
import { Route as AuthenticatedSetariTipuriDocumentRouteImport } from './routes/_authenticated/setari/tipuri-document'
import { Route as AuthenticatedSetariTipuriPachetRouteImport } from './routes/_authenticated/setari/tipuri-pachet'
import { Route as AuthenticatedTemplateUriIndexRouteImport } from './routes/_authenticated/template-uri/index'
import { Route as AuthenticatedTemplateUriTemplateIdRouteImport } from './routes/_authenticated/template-uri/$templateId'
import { Route as AuthenticatedSetariFirmeIndexRouteImport } from './routes/_authenticated/setari/firme/index'
import { Route as AuthenticatedSetariFirmeCompanyIdRouteImport } from './routes/_authenticated/setari/firme/$companyId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClientiRoute = AuthenticatedClientiRouteImport.update({
  id: '/clienti',
  path: '/clienti',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDocumenteRoute = AuthenticatedDocumenteRouteImport.update({
  id: '/documente',
  path: '/documente',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSetariRoute = AuthenticatedSetariRouteImport.update({
  id: '/setari',
  path: '/setari',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTehnicRoute = AuthenticatedTehnicRouteImport.update({
  id: '/tehnic',
  path: '/tehnic',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTemplateUriRoute =
  AuthenticatedTemplateUriRouteImport.update({
    id: '/template-uri',
    path: '/template-uri',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const SemnareTokenRoute = SemnareTokenRouteImport.update({
  id: '/semnare/$token',
  path: '/semnare/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedClientiIndexRoute =
  AuthenticatedClientiIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedClientiRoute,
  } as any)
const AuthenticatedClientiCustomerIdRoute =
  AuthenticatedClientiCustomerIdRouteImport.update({
    id: '/$customerId',
    path: '/$customerId',
    getParentRoute: () => AuthenticatedClientiRoute,
  } as any)
const AuthenticatedClientiNouRoute = AuthenticatedClientiNouRouteImport.update({
  id: '/nou',
  path: '/nou',
  getParentRoute: () => AuthenticatedClientiRoute,
} as any)
const AuthenticatedContaEfacturaRoute =
  AuthenticatedContaEfacturaRouteImport.update({
    id: '/conta/efactura',
    path: '/conta/efactura',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContaFacturareRoute =
  AuthenticatedContaFacturareRouteImport.update({
    id: '/conta/facturare',
    path: '/conta/facturare',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContaParteneriRoute =
  AuthenticatedContaParteneriRouteImport.update({
    id: '/conta/parteneri',
    path: '/conta/parteneri',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDocumenteIndexRoute =
  AuthenticatedDocumenteIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDocumenteRoute,
  } as any)
const AuthenticatedDocumenteDocumentIdRoute =
  AuthenticatedDocumenteDocumentIdRouteImport.update({
    id: '/$documentId',
    path: '/$documentId',
    getParentRoute: () => AuthenticatedDocumenteRoute,
  } as any)
const AuthenticatedDocumenteInAsteptareRoute =
  AuthenticatedDocumenteInAsteptareRouteImport.update({
    id: '/in-asteptare',
    path: '/in-asteptare',
    getParentRoute: () => AuthenticatedDocumenteRoute,
  } as any)
const AuthenticatedDocumenteIncarcaRoute =
  AuthenticatedDocumenteIncarcaRouteImport.update({
    id: '/incarca',
    path: '/incarca',
    getParentRoute: () => AuthenticatedDocumenteRoute,
  } as any)
const AuthenticatedSetariIndexRoute =
  AuthenticatedSetariIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSetariRoute,
  } as any)
const AuthenticatedSetariEmailRoute =
  AuthenticatedSetariEmailRouteImport.update({
    id: '/email',
    path: '/email',
    getParentRoute: () => AuthenticatedSetariRoute,
  } as any)
const AuthenticatedSetariJurnalRoute =
  AuthenticatedSetariJurnalRouteImport.update({
    id: '/jurnal',
    path: '/jurnal',
    getParentRoute: () => AuthenticatedSetariRoute,
  } as any)
const AuthenticatedSetariPacheteRoute =
  AuthenticatedSetariPacheteRouteImport.update({
    id: '/pachete',
    path: '/pachete',
    getParentRoute: () => AuthenticatedSetariRoute,
  } as any)
const AuthenticatedSetariProfileClientRoute =
  AuthenticatedSetariProfileClientRouteImport.update({
    id: '/profile-client',
    path: '/profile-client',
    getParentRoute: () => AuthenticatedSetariRoute,
  } as any)
const AuthenticatedSetariSpvRoute = AuthenticatedSetariSpvRouteImport.update({
  id: '/spv',
  path: '/spv',
  getParentRoute: () => AuthenticatedSetariRoute,
} as any)
const AuthenticatedSetariSurseDeDateRoute =
  AuthenticatedSetariSurseDeDateRouteImport.update({
    id: '/surse-de-date',
    path: '/surse-de-date',
    getParentRoute: () => AuthenticatedSetariRoute,
  } as any)
const AuthenticatedSetariTipuriDocumentRoute =
  AuthenticatedSetariTipuriDocumentRouteImport.update({
    id: '/tipuri-document',
    path: '/tipuri-document',
    getParentRoute: () => AuthenticatedSetariRoute,
  } as any)
const AuthenticatedSetariTipuriPachetRoute =
  AuthenticatedSetariTipuriPachetRouteImport.update({
    id: '/tipuri-pachet',
    path: '/tipuri-pachet',
    getParentRoute: () => AuthenticatedSetariRoute,
  } as any)
const AuthenticatedTemplateUriIndexRoute =
  AuthenticatedTemplateUriIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTemplateUriRoute,
  } as any)
const AuthenticatedTemplateUriTemplateIdRoute =
  AuthenticatedTemplateUriTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => AuthenticatedTemplateUriRoute,
  } as any)
const AuthenticatedSetariFirmeIndexRoute =
  AuthenticatedSetariFirmeIndexRouteImport.update({
    id: '/firme/',
    path: '/firme/',
    getParentRoute: () => AuthenticatedSetariRoute,
  } as any)
const AuthenticatedSetariFirmeCompanyIdRoute =
  AuthenticatedSetariFirmeCompanyIdRouteImport.update({
    id: '/firme/$companyId',
    path: '/firme/$companyId',
    getParentRoute: () => AuthenticatedSetariRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/clienti': typeof AuthenticatedClientiRouteWithChildren
  '/documente': typeof AuthenticatedDocumenteRouteWithChildren
  '/setari': typeof AuthenticatedSetariRouteWithChildren
  '/tehnic': typeof AuthenticatedTehnicRoute
  '/template-uri': typeof AuthenticatedTemplateUriRouteWithChildren
  '/semnare/$token': typeof SemnareTokenRoute
  '/clienti/$customerId': typeof AuthenticatedClientiCustomerIdRoute
  '/clienti/nou': typeof AuthenticatedClientiNouRoute
  '/conta/efactura': typeof AuthenticatedContaEfacturaRoute
  '/conta/facturare': typeof AuthenticatedContaFacturareRoute
  '/conta/parteneri': typeof AuthenticatedContaParteneriRoute
  '/documente/$documentId': typeof AuthenticatedDocumenteDocumentIdRoute
  '/documente/in-asteptare': typeof AuthenticatedDocumenteInAsteptareRoute
  '/documente/incarca': typeof AuthenticatedDocumenteIncarcaRoute
  '/setari/email': typeof AuthenticatedSetariEmailRoute
  '/setari/jurnal': typeof AuthenticatedSetariJurnalRoute
  '/setari/pachete': typeof AuthenticatedSetariPacheteRoute
  '/setari/profile-client': typeof AuthenticatedSetariProfileClientRoute
  '/setari/spv': typeof AuthenticatedSetariSpvRoute
  '/setari/surse-de-date': typeof AuthenticatedSetariSurseDeDateRoute
  '/setari/tipuri-document': typeof AuthenticatedSetariTipuriDocumentRoute
  '/setari/tipuri-pachet': typeof AuthenticatedSetariTipuriPachetRoute
  '/template-uri/$templateId': typeof AuthenticatedTemplateUriTemplateIdRoute
  '/clienti/': typeof AuthenticatedClientiIndexRoute
  '/documente/': typeof AuthenticatedDocumenteIndexRoute
  '/setari/': typeof AuthenticatedSetariIndexRoute
  '/template-uri/': typeof AuthenticatedTemplateUriIndexRoute
  '/setari/firme/$companyId': typeof AuthenticatedSetariFirmeCompanyIdRoute
  '/setari/firme/': typeof AuthenticatedSetariFirmeIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/tehnic': typeof AuthenticatedTehnicRoute
  '/semnare/$token': typeof SemnareTokenRoute
  '/': typeof AuthenticatedIndexRoute
  '/clienti/$customerId': typeof AuthenticatedClientiCustomerIdRoute
  '/clienti/nou': typeof AuthenticatedClientiNouRoute
  '/conta/efactura': typeof AuthenticatedContaEfacturaRoute
  '/conta/facturare': typeof AuthenticatedContaFacturareRoute
  '/conta/parteneri': typeof AuthenticatedContaParteneriRoute
  '/documente/$documentId': typeof AuthenticatedDocumenteDocumentIdRoute
  '/documente/in-asteptare': typeof AuthenticatedDocumenteInAsteptareRoute
  '/documente/incarca': typeof AuthenticatedDocumenteIncarcaRoute
  '/setari/email': typeof AuthenticatedSetariEmailRoute
  '/setari/jurnal': typeof AuthenticatedSetariJurnalRoute
  '/setari/pachete': typeof AuthenticatedSetariPacheteRoute
  '/setari/profile-client': typeof AuthenticatedSetariProfileClientRoute
  '/setari/spv': typeof AuthenticatedSetariSpvRoute
  '/setari/surse-de-date': typeof AuthenticatedSetariSurseDeDateRoute
  '/setari/tipuri-document': typeof AuthenticatedSetariTipuriDocumentRoute
  '/setari/tipuri-pachet': typeof AuthenticatedSetariTipuriPachetRoute
  '/template-uri/$templateId': typeof AuthenticatedTemplateUriTemplateIdRoute
  '/clienti': typeof AuthenticatedClientiIndexRoute
  '/documente': typeof AuthenticatedDocumenteIndexRoute
  '/setari': typeof AuthenticatedSetariIndexRoute
  '/template-uri': typeof AuthenticatedTemplateUriIndexRoute
  '/setari/firme/$companyId': typeof AuthenticatedSetariFirmeCompanyIdRoute
  '/setari/firme': typeof AuthenticatedSetariFirmeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/clienti': typeof AuthenticatedClientiRouteWithChildren
  '/_authenticated/documente': typeof AuthenticatedDocumenteRouteWithChildren
  '/_authenticated/setari': typeof AuthenticatedSetariRouteWithChildren
  '/_authenticated/tehnic': typeof AuthenticatedTehnicRoute
  '/_authenticated/template-uri': typeof AuthenticatedTemplateUriRouteWithChildren
  '/semnare/$token': typeof SemnareTokenRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/clienti/$customerId': typeof AuthenticatedClientiCustomerIdRoute
  '/_authenticated/clienti/nou': typeof AuthenticatedClientiNouRoute
  '/_authenticated/conta/efactura': typeof AuthenticatedContaEfacturaRoute
  '/_authenticated/conta/facturare': typeof AuthenticatedContaFacturareRoute
  '/_authenticated/conta/parteneri': typeof AuthenticatedContaParteneriRoute
  '/_authenticated/documente/$documentId': typeof AuthenticatedDocumenteDocumentIdRoute
  '/_authenticated/documente/in-asteptare': typeof AuthenticatedDocumenteInAsteptareRoute
  '/_authenticated/documente/incarca': typeof AuthenticatedDocumenteIncarcaRoute
  '/_authenticated/setari/email': typeof AuthenticatedSetariEmailRoute
  '/_authenticated/setari/jurnal': typeof AuthenticatedSetariJurnalRoute
  '/_authenticated/setari/pachete': typeof AuthenticatedSetariPacheteRoute
  '/_authenticated/setari/profile-client': typeof AuthenticatedSetariProfileClientRoute
  '/_authenticated/setari/spv': typeof AuthenticatedSetariSpvRoute
  '/_authenticated/setari/surse-de-date': typeof AuthenticatedSetariSurseDeDateRoute
  '/_authenticated/setari/tipuri-document': typeof AuthenticatedSetariTipuriDocumentRoute
  '/_authenticated/setari/tipuri-pachet': typeof AuthenticatedSetariTipuriPachetRoute
  '/_authenticated/template-uri/$templateId': typeof AuthenticatedTemplateUriTemplateIdRoute
  '/_authenticated/clienti/': typeof AuthenticatedClientiIndexRoute
  '/_authenticated/documente/': typeof AuthenticatedDocumenteIndexRoute
  '/_authenticated/setari/': typeof AuthenticatedSetariIndexRoute
  '/_authenticated/template-uri/': typeof AuthenticatedTemplateUriIndexRoute
  '/_authenticated/setari/firme/$companyId': typeof AuthenticatedSetariFirmeCompanyIdRoute
  '/_authenticated/setari/firme/': typeof AuthenticatedSetariFirmeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/clienti'
    | '/documente'
    | '/setari'
    | '/tehnic'
    | '/template-uri'
    | '/semnare/$token'
    | '/clienti/$customerId'
    | '/clienti/nou'
    | '/conta/efactura'
    | '/conta/facturare'
    | '/conta/parteneri'
    | '/documente/$documentId'
    | '/documente/in-asteptare'
    | '/documente/incarca'
    | '/setari/email'
    | '/setari/jurnal'
    | '/setari/pachete'
    | '/setari/profile-client'
    | '/setari/spv'
    | '/setari/surse-de-date'
    | '/setari/tipuri-document'
    | '/setari/tipuri-pachet'
    | '/template-uri/$templateId'
    | '/clienti/'
    | '/documente/'
    | '/setari/'
    | '/template-uri/'
    | '/setari/firme/$companyId'
    | '/setari/firme/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/tehnic'
    | '/semnare/$token'
    | '/'
    | '/clienti/$customerId'
    | '/clienti/nou'
    | '/conta/efactura'
    | '/conta/facturare'
    | '/conta/parteneri'
    | '/documente/$documentId'
    | '/documente/in-asteptare'
    | '/documente/incarca'
    | '/setari/email'
    | '/setari/jurnal'
    | '/setari/pachete'
    | '/setari/profile-client'
    | '/setari/spv'
    | '/setari/surse-de-date'
    | '/setari/tipuri-document'
    | '/setari/tipuri-pachet'
    | '/template-uri/$templateId'
    | '/clienti'
    | '/documente'
    | '/setari'
    | '/template-uri'
    | '/setari/firme/$companyId'
    | '/setari/firme'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/clienti'
    | '/_authenticated/documente'
    | '/_authenticated/setari'
    | '/_authenticated/tehnic'
    | '/_authenticated/template-uri'
    | '/semnare/$token'
    | '/_authenticated/'
    | '/_authenticated/clienti/$customerId'
    | '/_authenticated/clienti/nou'
    | '/_authenticated/conta/efactura'
    | '/_authenticated/conta/facturare'
    | '/_authenticated/conta/parteneri'
    | '/_authenticated/documente/$documentId'
    | '/_authenticated/documente/in-asteptare'
    | '/_authenticated/documente/incarca'
    | '/_authenticated/setari/email'
    | '/_authenticated/setari/jurnal'
    | '/_authenticated/setari/pachete'
    | '/_authenticated/setari/profile-client'
    | '/_authenticated/setari/spv'
    | '/_authenticated/setari/surse-de-date'
    | '/_authenticated/setari/tipuri-document'
    | '/_authenticated/setari/tipuri-pachet'
    | '/_authenticated/template-uri/$templateId'
    | '/_authenticated/clienti/'
    | '/_authenticated/documente/'
    | '/_authenticated/setari/'
    | '/_authenticated/template-uri/'
    | '/_authenticated/setari/firme/$companyId'
    | '/_authenticated/setari/firme/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SemnareTokenRoute: typeof SemnareTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clienti': {
      id: '/_authenticated/clienti'
      path: '/clienti'
      fullPath: '/clienti'
      preLoaderRoute: typeof AuthenticatedClientiRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documente': {
      id: '/_authenticated/documente'
      path: '/documente'
      fullPath: '/documente'
      preLoaderRoute: typeof AuthenticatedDocumenteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/setari': {
      id: '/_authenticated/setari'
      path: '/setari'
      fullPath: '/setari'
      preLoaderRoute: typeof AuthenticatedSetariRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tehnic': {
      id: '/_authenticated/tehnic'
      path: '/tehnic'
      fullPath: '/tehnic'
      preLoaderRoute: typeof AuthenticatedTehnicRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/template-uri': {
      id: '/_authenticated/template-uri'
      path: '/template-uri'
      fullPath: '/template-uri'
      preLoaderRoute: typeof AuthenticatedTemplateUriRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/semnare/$token': {
      id: '/semnare/$token'
      path: '/semnare/$token'
      fullPath: '/semnare/$token'
      preLoaderRoute: typeof SemnareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/clienti/': {
      id: '/_authenticated/clienti/'
      path: '/'
      fullPath: '/clienti/'
      preLoaderRoute: typeof AuthenticatedClientiIndexRouteImport
      parentRoute: typeof AuthenticatedClientiRoute
    }
    '/_authenticated/clienti/$customerId': {
      id: '/_authenticated/clienti/$customerId'
      path: '/$customerId'
      fullPath: '/clienti/$customerId'
      preLoaderRoute: typeof AuthenticatedClientiCustomerIdRouteImport
      parentRoute: typeof AuthenticatedClientiRoute
    }
    '/_authenticated/clienti/nou': {
      id: '/_authenticated/clienti/nou'
      path: '/nou'
      fullPath: '/clienti/nou'
      preLoaderRoute: typeof AuthenticatedClientiNouRouteImport
      parentRoute: typeof AuthenticatedClientiRoute
    }
    '/_authenticated/conta/efactura': {
      id: '/_authenticated/conta/efactura'
      path: '/conta/efactura'
      fullPath: '/conta/efactura'
      preLoaderRoute: typeof AuthenticatedContaEfacturaRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/conta/facturare': {
      id: '/_authenticated/conta/facturare'
      path: '/conta/facturare'
      fullPath: '/conta/facturare'
      preLoaderRoute: typeof AuthenticatedContaFacturareRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/conta/parteneri': {
      id: '/_authenticated/conta/parteneri'
      path: '/conta/parteneri'
      fullPath: '/conta/parteneri'
      preLoaderRoute: typeof AuthenticatedContaParteneriRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documente/': {
      id: '/_authenticated/documente/'
      path: '/'
      fullPath: '/documente/'
      preLoaderRoute: typeof AuthenticatedDocumenteIndexRouteImport
      parentRoute: typeof AuthenticatedDocumenteRoute
    }
    '/_authenticated/documente/$documentId': {
      id: '/_authenticated/documente/$documentId'
      path: '/$documentId'
      fullPath: '/documente/$documentId'
      preLoaderRoute: typeof AuthenticatedDocumenteDocumentIdRouteImport
      parentRoute: typeof AuthenticatedDocumenteRoute
    }
    '/_authenticated/documente/in-asteptare': {
      id: '/_authenticated/documente/in-asteptare'
      path: '/in-asteptare'
      fullPath: '/documente/in-asteptare'
      preLoaderRoute: typeof AuthenticatedDocumenteInAsteptareRouteImport
      parentRoute: typeof AuthenticatedDocumenteRoute
    }
    '/_authenticated/documente/incarca': {
      id: '/_authenticated/documente/incarca'
      path: '/incarca'
      fullPath: '/documente/incarca'
      preLoaderRoute: typeof AuthenticatedDocumenteIncarcaRouteImport
      parentRoute: typeof AuthenticatedDocumenteRoute
    }
    '/_authenticated/setari/': {
      id: '/_authenticated/setari/'
      path: '/'
      fullPath: '/setari/'
      preLoaderRoute: typeof AuthenticatedSetariIndexRouteImport
      parentRoute: typeof AuthenticatedSetariRoute
    }
    '/_authenticated/setari/email': {
      id: '/_authenticated/setari/email'
      path: '/email'
      fullPath: '/setari/email'
      preLoaderRoute: typeof AuthenticatedSetariEmailRouteImport
      parentRoute: typeof AuthenticatedSetariRoute
    }
    '/_authenticated/setari/jurnal': {
      id: '/_authenticated/setari/jurnal'
      path: '/jurnal'
      fullPath: '/setari/jurnal'
      preLoaderRoute: typeof AuthenticatedSetariJurnalRouteImport
      parentRoute: typeof AuthenticatedSetariRoute
    }
    '/_authenticated/setari/pachete': {
      id: '/_authenticated/setari/pachete'
      path: '/pachete'
      fullPath: '/setari/pachete'
      preLoaderRoute: typeof AuthenticatedSetariPacheteRouteImport
      parentRoute: typeof AuthenticatedSetariRoute
    }
    '/_authenticated/setari/profile-client': {
      id: '/_authenticated/setari/profile-client'
      path: '/profile-client'
      fullPath: '/setari/profile-client'
      preLoaderRoute: typeof AuthenticatedSetariProfileClientRouteImport
      parentRoute: typeof AuthenticatedSetariRoute
    }
    '/_authenticated/setari/spv': {
      id: '/_authenticated/setari/spv'
      path: '/spv'
      fullPath: '/setari/spv'
      preLoaderRoute: typeof AuthenticatedSetariSpvRouteImport
      parentRoute: typeof AuthenticatedSetariRoute
    }
    '/_authenticated/setari/surse-de-date': {
      id: '/_authenticated/setari/surse-de-date'
      path: '/surse-de-date'
      fullPath: '/setari/surse-de-date'
      preLoaderRoute: typeof AuthenticatedSetariSurseDeDateRouteImport
      parentRoute: typeof AuthenticatedSetariRoute
    }
    '/_authenticated/setari/tipuri-document': {
      id: '/_authenticated/setari/tipuri-document'
      path: '/tipuri-document'
      fullPath: '/setari/tipuri-document'
      preLoaderRoute: typeof AuthenticatedSetariTipuriDocumentRouteImport
      parentRoute: typeof AuthenticatedSetariRoute
    }
    '/_authenticated/setari/tipuri-pachet': {
      id: '/_authenticated/setari/tipuri-pachet'
      path: '/tipuri-pachet'
      fullPath: '/setari/tipuri-pachet'
      preLoaderRoute: typeof AuthenticatedSetariTipuriPachetRouteImport
      parentRoute: typeof AuthenticatedSetariRoute
    }
    '/_authenticated/template-uri/': {
      id: '/_authenticated/template-uri/'
      path: '/'
      fullPath: '/template-uri/'
      preLoaderRoute: typeof AuthenticatedTemplateUriIndexRouteImport
      parentRoute: typeof AuthenticatedTemplateUriRoute
    }
    '/_authenticated/template-uri/$templateId': {
      id: '/_authenticated/template-uri/$templateId'
      path: '/$templateId'
      fullPath: '/template-uri/$templateId'
      preLoaderRoute: typeof AuthenticatedTemplateUriTemplateIdRouteImport
      parentRoute: typeof AuthenticatedTemplateUriRoute
    }
    '/_authenticated/setari/firme/': {
      id: '/_authenticated/setari/firme/'
      path: '/firme'
      fullPath: '/setari/firme/'
      preLoaderRoute: typeof AuthenticatedSetariFirmeIndexRouteImport
      parentRoute: typeof AuthenticatedSetariRoute
    }
    '/_authenticated/setari/firme/$companyId': {
      id: '/_authenticated/setari/firme/$companyId'
      path: '/firme/$companyId'
      fullPath: '/setari/firme/$companyId'
      preLoaderRoute: typeof AuthenticatedSetariFirmeCompanyIdRouteImport
      parentRoute: typeof AuthenticatedSetariRoute
    }
  }
}

interface AuthenticatedClientiRouteChildren {
  AuthenticatedClientiCustomerIdRoute: typeof AuthenticatedClientiCustomerIdRoute
  AuthenticatedClientiNouRoute: typeof AuthenticatedClientiNouRoute
  AuthenticatedClientiIndexRoute: typeof AuthenticatedClientiIndexRoute
}

const AuthenticatedClientiRouteChildren: AuthenticatedClientiRouteChildren = {
  AuthenticatedClientiCustomerIdRoute: AuthenticatedClientiCustomerIdRoute,
  AuthenticatedClientiNouRoute: AuthenticatedClientiNouRoute,
  AuthenticatedClientiIndexRoute: AuthenticatedClientiIndexRoute,
}

const AuthenticatedClientiRouteWithChildren =
  AuthenticatedClientiRoute._addFileChildren(AuthenticatedClientiRouteChildren)

interface AuthenticatedDocumenteRouteChildren {
  AuthenticatedDocumenteDocumentIdRoute: typeof AuthenticatedDocumenteDocumentIdRoute
  AuthenticatedDocumenteInAsteptareRoute: typeof AuthenticatedDocumenteInAsteptareRoute
  AuthenticatedDocumenteIncarcaRoute: typeof AuthenticatedDocumenteIncarcaRoute
  AuthenticatedDocumenteIndexRoute: typeof AuthenticatedDocumenteIndexRoute
}

const AuthenticatedDocumenteRouteChildren: AuthenticatedDocumenteRouteChildren =
  {
    AuthenticatedDocumenteDocumentIdRoute:
      AuthenticatedDocumenteDocumentIdRoute,
    AuthenticatedDocumenteInAsteptareRoute:
      AuthenticatedDocumenteInAsteptareRoute,
    AuthenticatedDocumenteIncarcaRoute: AuthenticatedDocumenteIncarcaRoute,
    AuthenticatedDocumenteIndexRoute: AuthenticatedDocumenteIndexRoute,
  }

const AuthenticatedDocumenteRouteWithChildren =
  AuthenticatedDocumenteRoute._addFileChildren(
    AuthenticatedDocumenteRouteChildren,
  )

interface AuthenticatedSetariRouteChildren {
  AuthenticatedSetariEmailRoute: typeof AuthenticatedSetariEmailRoute
  AuthenticatedSetariJurnalRoute: typeof AuthenticatedSetariJurnalRoute
  AuthenticatedSetariPacheteRoute: typeof AuthenticatedSetariPacheteRoute
  AuthenticatedSetariProfileClientRoute: typeof AuthenticatedSetariProfileClientRoute
  AuthenticatedSetariSpvRoute: typeof AuthenticatedSetariSpvRoute
  AuthenticatedSetariSurseDeDateRoute: typeof AuthenticatedSetariSurseDeDateRoute
  AuthenticatedSetariTipuriDocumentRoute: typeof AuthenticatedSetariTipuriDocumentRoute
  AuthenticatedSetariTipuriPachetRoute: typeof AuthenticatedSetariTipuriPachetRoute
  AuthenticatedSetariIndexRoute: typeof AuthenticatedSetariIndexRoute
  AuthenticatedSetariFirmeCompanyIdRoute: typeof AuthenticatedSetariFirmeCompanyIdRoute
  AuthenticatedSetariFirmeIndexRoute: typeof AuthenticatedSetariFirmeIndexRoute
}

const AuthenticatedSetariRouteChildren: AuthenticatedSetariRouteChildren = {
  AuthenticatedSetariEmailRoute: AuthenticatedSetariEmailRoute,
  AuthenticatedSetariJurnalRoute: AuthenticatedSetariJurnalRoute,
  AuthenticatedSetariPacheteRoute: AuthenticatedSetariPacheteRoute,
  AuthenticatedSetariProfileClientRoute: AuthenticatedSetariProfileClientRoute,
  AuthenticatedSetariSpvRoute: AuthenticatedSetariSpvRoute,
  AuthenticatedSetariSurseDeDateRoute: AuthenticatedSetariSurseDeDateRoute,
  AuthenticatedSetariTipuriDocumentRoute:
    AuthenticatedSetariTipuriDocumentRoute,
  AuthenticatedSetariTipuriPachetRoute: AuthenticatedSetariTipuriPachetRoute,
  AuthenticatedSetariIndexRoute: AuthenticatedSetariIndexRoute,
  AuthenticatedSetariFirmeCompanyIdRoute:
    AuthenticatedSetariFirmeCompanyIdRoute,
  AuthenticatedSetariFirmeIndexRoute: AuthenticatedSetariFirmeIndexRoute,
}

const AuthenticatedSetariRouteWithChildren =
  AuthenticatedSetariRoute._addFileChildren(AuthenticatedSetariRouteChildren)

interface AuthenticatedTemplateUriRouteChildren {
  AuthenticatedTemplateUriTemplateIdRoute: typeof AuthenticatedTemplateUriTemplateIdRoute
  AuthenticatedTemplateUriIndexRoute: typeof AuthenticatedTemplateUriIndexRoute
}

const AuthenticatedTemplateUriRouteChildren: AuthenticatedTemplateUriRouteChildren =
  {
    AuthenticatedTemplateUriTemplateIdRoute:
      AuthenticatedTemplateUriTemplateIdRoute,
    AuthenticatedTemplateUriIndexRoute: AuthenticatedTemplateUriIndexRoute,
  }

const AuthenticatedTemplateUriRouteWithChildren =
  AuthenticatedTemplateUriRoute._addFileChildren(
    AuthenticatedTemplateUriRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedClientiRoute: typeof AuthenticatedClientiRouteWithChildren
  AuthenticatedDocumenteRoute: typeof AuthenticatedDocumenteRouteWithChildren
  AuthenticatedSetariRoute: typeof AuthenticatedSetariRouteWithChildren
  AuthenticatedTehnicRoute: typeof AuthenticatedTehnicRoute
  AuthenticatedTemplateUriRoute: typeof AuthenticatedTemplateUriRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedContaEfacturaRoute: typeof AuthenticatedContaEfacturaRoute
  AuthenticatedContaFacturareRoute: typeof AuthenticatedContaFacturareRoute
  AuthenticatedContaParteneriRoute: typeof AuthenticatedContaParteneriRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedClientiRoute: AuthenticatedClientiRouteWithChildren,
  AuthenticatedDocumenteRoute: AuthenticatedDocumenteRouteWithChildren,
  AuthenticatedSetariRoute: AuthenticatedSetariRouteWithChildren,
  AuthenticatedTehnicRoute: AuthenticatedTehnicRoute,
  AuthenticatedTemplateUriRoute: AuthenticatedTemplateUriRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedContaEfacturaRoute: AuthenticatedContaEfacturaRoute,
  AuthenticatedContaFacturareRoute: AuthenticatedContaFacturareRoute,
  AuthenticatedContaParteneriRoute: AuthenticatedContaParteneriRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  SemnareTokenRoute: SemnareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
